import {
  TerminalEventPayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createTerminalEventMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: TerminalEventPayload) => {
    try {
      // The relay only ever pushes MODIFY: a terminal event is a transient signal, never a row.
      if (action !== WebSocketAction.MODIFY) {
        log.debug('[TerminalEventHandler] Ignoring action:', action);
        return;
      }

      eventEmitter.emit(
        WebSocketEntityType.TerminalEvent,
        WebSocketEventType.MODIFY,
        item,
      );
    } catch (error) {
      log.error('[TerminalEventHandler] Handler failed:', error);
    }
  };
}
